export default __webpack_public_path__ + "static/media/orange-logo.235dbbbd.jpeg";